import React from "react";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";
import "./index.scss";
import Utils from "../../../../../../shared/utils";
import AnchorTagWithQueryParams from "../../../../../anchor-tag-with-params";
import useHeader from "../../../../hooks/useHeader";

const FIRST_COLUMN_SIZE_BY_MENU = {
  השכרה: 5,
  "מידע מקצועי": 5,
  בלוג: 5,
};

/** Match home header: dropdown right edge aligns with nav link; bar sits on top (-3px). */
const alignNavDropdownPosition = (
  position,
  _event,
  currentTarget,
  tooltipNode
) => {
  if (!currentTarget || !tooltipNode) {
    return position;
  }

  const offsetParent = tooltipNode.offsetParent;
  const parentRect = offsetParent?.getBoundingClientRect?.() ?? {
    left: 0,
    top: 0,
  };
  const anchorRect = currentTarget.getBoundingClientRect();
  const tipWidth = tooltipNode.offsetWidth;

  if (!tipWidth) {
    return position;
  }

  return {
    left: Math.round(anchorRect.right - tipWidth - parentRect.left),
    top: Math.round(anchorRect.bottom - parentRect.top - 3),
  };
};

const renderInnerLabel = (innerLink) => (
  <>
    {innerLink.label}
    {innerLink.badge ? (
      <span className="header-nav-badge">{innerLink.badge}</span>
    ) : null}
  </>
);

export default function DesktopLinksList({
  link,
  isNewSiteActive,
  isMortPersonalAreaActive,
}) {
  const { isRentAISite } = useHeader();
  const firstColumnSize = FIRST_COLUMN_SIZE_BY_MENU[link.text] ?? 4;
  const firstColumnLinks = link.links.slice(0, firstColumnSize);
  const secondColumnLinks = link.links.slice(firstColumnSize);

  return (
    <ReactTooltip
      id={link.label}
      place="bottom"
      type="light"
      effect="solid"
      className={`tooltip-container${
        isRentAISite ? " newsletter-nav-tooltip" : ""
      }`}
      delayHide={100}
      overridePosition={alignNavDropdownPosition}
      arrowColor="transparent" // Hides the default arrow
    >
      <div className="tooltip-accent-bar" aria-hidden="true" />
      <div className="links-tooltip-container">
        <div className="links-column">
          {firstColumnLinks.map((innerLink, index) => {
            return innerLink.isPremium &&
              !isNewSiteActive ? null : innerLink.personalArea &&
              !isMortPersonalAreaActive ? null : innerLink.external ? (
              <AnchorTagWithQueryParams
                key={index}
                className={`header-link ${innerLink.bold ? "text-bold" : ""} ${
                  link.bold ? "text-bold" : ""
                }`}
                href={innerLink.to}
                overRideDefaultQueryParams={
                  innerLink.overRideDefaultQueryParams
                }
              >
                {renderInnerLabel(innerLink)}
              </AnchorTagWithQueryParams>
            ) : (
              <Link
                onClick={() =>
                  Utils.gaEvent(
                    innerLink.category,
                    innerLink.action,
                    innerLink.label
                  )
                }
                to={innerLink.to}
                key={index}
              >
                {renderInnerLabel(innerLink)}
              </Link>
            );
          })}
        </div>

        {secondColumnLinks.length > 0 && (
          <div className="links-column">
            {secondColumnLinks.map((innerLink, index) => {
              return innerLink.isPremium &&
                !isNewSiteActive ? null : innerLink.personalArea &&
                !isMortPersonalAreaActive ? null : innerLink.external ? (
                <AnchorTagWithQueryParams
                  key={index + firstColumnSize}
                  className={`header-link ${
                    innerLink.bold ? "text-bold" : ""
                  } ${link.bold ? "text-bold" : ""}`}
                  href={innerLink.to}
                  overRideDefaultQueryParams={
                    innerLink.overRideDefaultQueryParams
                  }
                >
                  {renderInnerLabel(innerLink)}
                </AnchorTagWithQueryParams>
              ) : (
                <Link
                  onClick={() =>
                    Utils.gaEvent(
                      innerLink.category,
                      innerLink.action,
                      innerLink.label
                    )
                  }
                  to={innerLink.to}
                  key={index + firstColumnSize}
                >
                  {renderInnerLabel(innerLink)}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </ReactTooltip>
  );
}
